import { CgGym } from "react-icons/cg";
import { FaRunning } from "react-icons/fa";
import { BsFire } from "react-icons/bs";
import { FaHeartCirclePlus } from "react-icons/fa6";

// w: 16 - h: 15
export const programsData = [
  {
    image: <CgGym aria-label="dumbbell icon"/>,
    heading: "Strength Training",
    details:
      "In this program, you are trained to improve your strength through many exercises.",
  },
  {
    image: <FaRunning aria-label="icon of a person running"/>,
    heading: "Cardio Training",
    details:
      "In this program, you are trained to do sequential moves in range of 20 until 30 minutes.",
  },
  {
    image: <BsFire aria-label="fire icon"/>,
    heading: "Fat Burning",
    details:
      "This program is suitable for you who wants to get rid of your fat and lose their weight.",
  },
  {
    image: <FaHeartCirclePlus aria-label="heart icon"/>,
    heading: "Health Fitness",
    details:
      "This programs is designed for those who exercises only for their body fitness not body building.",
  },
];



